import type { ThrownResponse } from '@remix-run/react'

interface CatchBoundaryProps {
  errorTitle: string
  message: string
  caught: ThrownResponse<number, any>
}

export default function CatchBoundaryContainer(props: CatchBoundaryProps) {
  const { errorTitle, message, caught } = props

  return (
    <div className="mx-auto max-w-screen-md px-4 pt-16">
      <div className="flex flex-col items-center rounded">
        <h1 className="mb-3 text-3xl font-bold lg:text-5xl">
          {errorTitle} {caught?.status}
        </h1>
        <p className="mb-0 text-lg">{message}</p>
      </div>
    </div>
  )
}
